function PerfectButtonIconRight({width=20,height=20 , fillColor= "white"}) {
    return (
        <svg width={width} height={height} viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 5.83881L5.17647 1.60352M12.2353 10.78L2 10.78M14 15.3682L8 18.8976" stroke={fillColor}
             stroke-width="2.11765" stroke-linecap="round" />
        </svg>
    )
}
export default PerfectButtonIconRight;